<script lang="ts" setup>
import { Employee } from './EmployeeSingle.vue'

defineProps<{ data: Employee }>()

const controller = useModal()
</script>
<template>
  <PersonBase :person="data">
    <button v-if="data.link?.url" class="link-default more" @click="controller.open">
      {{ data.link?.text }}
    </button>
    <ModalEmployee :controller="controller">
      <EmployeeSingle :data="data" />
    </ModalEmployee>
  </PersonBase>
</template>
